import mapTypes from "./map.types";

const INITIAL_STATE = {
    map: {},
    myLocation: [],
    iconLayers: [],
    reportLayer: [],
    isMain: false,
    isLive: false,
    MountLiveTime: null,
    timer: null, // FOR LIVE SHOW
    counter: 20,
    path: [],
    refresher: null, // FOR MAIN
    refreshTime: 20,
};

const mapReducer = (state = INITIAL_STATE , action) => {
    switch (action.type){
        case mapTypes.SET_MAP :
            return{
                ...state,
                map: action.payload
            };
        case mapTypes.MY_LOCATION :
            return{
                ...state,
                myLocation: state.myLocation.push(1)
            };
        case mapTypes.ICONS_LAYER :
            return{
                ...state,
                iconLayers: [...state.iconLayers , action.payload]
            };
        case mapTypes.CLEAR_ICONS_LAYER :
            return{
                ...state,
                iconLayers: []
            };
        case mapTypes.ADD_REPORT_LAYER :
            return{
                ...state,
                reportLayer: [...state.reportLayer, action.payload]
            };
        case mapTypes.CLEAR_REPORT_LAYER :
            return{
                ...state,
                reportLayer: []
            };
        case mapTypes.TOGGLE_IS_MAIN :
            return{
                ...state,
                isMain: !state.isMain
            };
        case mapTypes.TOGGLE_IS_LIVE :
            return{
                ...state,
                isLive: !state.isLive
            };
            //LIVE SHOW TIMER
        case mapTypes.SET_MOUNT_LIVE_TIME :
            return{
                ...state,
                MountLiveTime: action.payload
            };
        case mapTypes.START_COUNT_DOWN :
            return{
                ...state,
                counter: state.counter - 1
            };
        case mapTypes.REFRESH_COUNTER :
            return{
                ...state,
                counter: action.payload
            };
        case mapTypes.SET_TIMER :
            return{
                ...state,
                timer: action.payload
            };
            //LIVE PATH
        case mapTypes.SET_LIVE_PATH:
            return{
                ...state,
                path: action.payload
            };
            //MAIN TIMER
        case mapTypes.CHOOSE_MAIN_REFRESHER :
            return{
                ...state,
                refreshTime: action.payload
            };
        case mapTypes.SET_REFRESHER :
            return{
                ...state,
                refresher: action.payload
            };
        case mapTypes.REFRESH_REFRESHER :
            return{
                ...state,
                refreshTime: action.payload
            };
        case mapTypes.REFRESHER_COUNT_DOWN :
            return{
                ...state,
                refreshTime: state.refreshTime - 1
            };
        default:
            return state
    }
};

export default mapReducer